import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'
import { IdentityEvent } from '../../../common/events/identity'
import { IdentityScreen } from '../../enums'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityFormAPI } from './form-api'
import { IdentityFormUtils } from './form-utils'

export class ForgotPasswordForm {
    private static DOM = {
        form: 'forgotPasswordForm'
    }
    private submissionEventName = 'forgot-password'

    /**
     * Listens for the form validated event in the Forgot Password form
     */
    public init() {
        logger('debug', 'Initializing Forgot Password form')
        const form = this.getFormElement()

        if (form) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED, async (event: CustomEvent) => {
                const formType = event.detail.form
                if (formType === ForgotPasswordForm.DOM.form) {
                    await this.submitForm(form)
                }
            })
             // show the form
            DOMUtils.addClass(document.body, 'identity-screen-form--active')
        }
        logger('debug', 'Forgot Password form initialized')
    }

    /**
     * Calls Forgot Password LR API endpoint
     */
    public async submitForm(form: HTMLFormElement) {
        const formData = new FormData(form)
        // The dataObj creation below might be simplified with the Object.fromEntries but our current
        // ts config doesn't recognize it.
        const dataObj: Record<string, unknown> & {csrfmiddlewaretoken: string} = {csrfmiddlewaretoken: undefined}
        formData.forEach((value, key) => dataObj[key] = value)

        try {
            await IdentityFormAPI.sendResetPasswordEmail(dataObj)
            return this.onSuccess()
        } catch (error) {
            const errors = IdentityFormUtils.structureErrors(error)
            return this.onError(errors)
        }
    }

    /**
     * Success callback function
     */
    protected onSuccess() {
        LoginService.sendFormSubmissionEvent(this.submissionEventName)
        // hide form and show success message
        DOMUtils.removeClass(document.body, IdentityScreen.FORM)
        DOMUtils.addClass(document.body, IdentityScreen.SUCCESS)
    }

    /**
     * Error callback function
     * @param errors any
     *
     */
    protected onError(errors: any) {
        logger('error', errors)
        LoginService.sendSubmissionErrorAnalytics(errors, this.submissionEventName)
        LoginService.clearErrors()
        LoginService.showErrors(errors)
    }

    /**
     * Get HTMLFormElement representation of the Email Verification form
     */
    private getFormElement(): HTMLFormElement | undefined {
        return document.querySelector(`[data-id-form=${ForgotPasswordForm.DOM.form}]`)
    }
}
